import { ElementType, ReactNode } from 'react';

/**
 * Sticky section title.
 * When `nested`, a join row draws the rounded L into NestedSectionRail.
 * Leaf headings use side seals so card borders don’t read as hairlines at the
 * underline ends; cards below keep normal spacing and rounded corners.
 */
export default function StickySectionHeading({
  level,
  as: Tag = 'h2',
  nested = false,
  className = '',
  children,
}: {
  level: number;
  as?: ElementType;
  nested?: boolean;
  className?: string;
  children: ReactNode;
}) {
  const top = level <= 0 ? 'top-24' : 'top-36';
  const z = level <= 0 ? 'z-20' : 'z-10';
  const edgeSeal = 'shadow-[-2px_0_0_0_#fff,2px_0_0_0_#fff]';

  if (!nested) {
    return (
      <Tag
        tabIndex={-1}
        className={`sticky ${top} ${z} ${edgeSeal} bg-white py-2 border-b border-gray-200 focus-ring rounded-sm ${className}`}
      >
        {children}
      </Tag>
    );
  }

  return (
    <div className={`sticky ${top} ${z} isolate bg-white ${edgeSeal}`}>
      <Tag tabIndex={-1} className={`pt-2 pb-1 focus-ring rounded-sm ${className}`}>
        {children}
      </Tag>
      <div className="relative h-2 bg-white" aria-hidden>
        <div className="absolute inset-0 bg-white" />
        <div className="absolute left-2 right-0 top-0 h-px bg-gray-200" />
        <svg
          width="8"
          height="8"
          viewBox="0 0 8 8"
          className="absolute left-0 top-0 overflow-visible"
        >
          <path
            d="M 0.5 8 A 7.5 7.5 0 0 1 8 0.5"
            fill="none"
            stroke="#e5e7eb"
            strokeWidth="1"
          />
        </svg>
      </div>
    </div>
  );
}
